(function () {
    'use strict';

    angular.module("imApp").factory("stockCorrCodesService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockCorrectionCodes: function (parms) {
                return $ihttp.post({
                    method: 2482,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
